export type HotelGroup = {
  readonly id: number;
  readonly name: string;
};

export function createHotelGroup(values: unknown): HotelGroup {
  const { id, name } = values as HotelGroup;

  return {
    id,
    name,
  };
}
